import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useI18n } from "@/i18n";

export const RelatedChaptersSection = ({ chapters, locked }) => {
  const { t, lang } = useI18n();

  if (!chapters || chapters.length === 0) return null;

  return (
    <section className="mt-12" aria-labelledby="ws-related-chapters" data-testid="workspace-related-chapters">
      <h2 id="ws-related-chapters" className="caption m-0 mb-3 text-ax-muted">
        {t("ws.relatedChapters")}
      </h2>
      <ul className="m-0 grid list-none gap-3 p-0 md:grid-cols-3">
        {chapters.map((ch) => {
          const bTitle = typeof ch.bookTitle === "object" ? ch.bookTitle[lang] || ch.bookTitle.id : ch.bookTitle;
          const cTitle = typeof ch.chapterTitle === "object" ? ch.chapterTitle[lang] || ch.chapterTitle.id : ch.chapterTitle;

          return (
            <li key={`${ch.bookId}-${ch.chapterId}`}>
              <Link
                to={`/library/${ch.bookId}/bab/${ch.chapterId}`}
                data-testid={`related-chapter-${ch.chapterId}`}
                className="group flex h-full flex-col justify-between rounded-[12px] border border-ax-border bg-ax-surface p-4 shadow transition-colors duration-150 hover:bg-ax-bg focus:outline-none focus:ring-2 focus:ring-ax-border-focus block no-underline"
              >
                <div>
                  <p className="m-0 font-mono text-[12px] uppercase tracking-wider text-ax-muted [overflow-wrap:anywhere]">
                    {bTitle}
                  </p>
                  <p className="m-0 mt-1 text-base font-medium leading-6 text-ax-text [overflow-wrap:anywhere] group-hover:text-ax-link">
                    {cTitle}
                  </p>
                </div>
                {locked && (
                  <div className="mt-3 flex items-center gap-1.5 font-mono text-[12px] text-ax-muted">
                    <Lock size={14} strokeWidth={1.5} aria-hidden="true" />
                    <span>{t("lib.lockedCard")}</span>
                  </div>
                )}
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
};
